<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-group element-bodymatter element-type-volume element-with-heading" epub:type="volume" id="vol-1">
<div class="heading heading-with-title heading-without-image" id="vol-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">The Wish Shore</h1>
</div>
</div>
<div class="element-heading-author-block">
<h2 class="author">Kristen Bickerstaff</h2>
</div>
</div>
</div>
<div class="text" id="vol-1-text">
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001.vue?e883d9be